import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getConsent, saveConsent, openPreferences, PREFERENCES_EVENT, CONSENT_EVENT } from '../analytics/consent';
import { publicPath } from '../analytics/catalog';
import './CookieConsent.css';

export function CookiePreferencesButton() {
  return <button type="button" className="cookie-preferences-link" onClick={openPreferences}>Preferências de cookies</button>;
}
export default function CookieConsent() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(() => getConsent() === 'unknown');
  const [expanded, setExpanded] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const firstButton = useRef<HTMLButtonElement>(null);
  const previousFocus = useRef<HTMLElement | null>(null);
  useEffect(() => {
    const open = () => {
      previousFocus.current = document.activeElement as HTMLElement;
      setAnalytics(getConsent() === 'granted'); setExpanded(true); setVisible(true);
    };
    const changed = () => setVisible(getConsent() === 'unknown');
    window.addEventListener(PREFERENCES_EVENT, open); window.addEventListener(CONSENT_EVENT, changed); window.addEventListener('storage', changed);
    return () => { window.removeEventListener(PREFERENCES_EVENT, open); window.removeEventListener(CONSENT_EVENT, changed); window.removeEventListener('storage', changed); };
  }, []);
  useEffect(() => { if (visible && expanded) firstButton.current?.focus(); }, [visible, expanded]);
  useEffect(() => { document.documentElement.classList.toggle('cookie-notice-open', visible && !!publicPath(pathname));
    return () => document.documentElement.classList.remove('cookie-notice-open');
  }, [visible, pathname]);
  const choose = (allowed: boolean) => {
    saveConsent(allowed ? 'granted' : 'denied'); setVisible(false); setExpanded(false);
    previousFocus.current?.focus();
  };
  if (!visible || !publicPath(pathname)) return null;
  return <aside className="cookie-notice" aria-labelledby="cookie-title" data-clarity-mask="true">
    <h2 id="cookie-title">Sua privacidade, sua escolha</h2>
    <p>Com sua autorização, usamos Google Analytics e Microsoft Clarity para entender a navegação e melhorar o site.
      Você pode recusar e continuar usando todos os contatos. <Link to="/privacidade">Política de Privacidade</Link>.</p>
    {expanded && <div className="cookie-options">
      <p><strong>Essenciais:</strong> guardam sua preferência de privacidade e permanecem ativos.</p>
      <label><input type="checkbox" checked={analytics} onChange={e => setAnalytics(e.target.checked)} />
        Permitir métricas de navegação e mapas de calor</label>
      <p>Não usamos esta escolha para autorizar publicidade ou mensagens de marketing.</p>
    </div>}
    <div className="cookie-actions">
      <button ref={firstButton} type="button" onClick={() => choose(false)}>Rejeitar analytics</button>
      <button type="button" onClick={() => choose(true)}>Aceitar analytics</button>
      {expanded ? <button type="button" onClick={() => choose(analytics)}>Salvar preferências</button>
        : <button type="button" onClick={() => { setAnalytics(false); setExpanded(true); }}>Ajustar preferências</button>}
    </div>
  </aside>;
}
